// import emailjs from 'emailjs-com';
import emailjs from '@emailjs/browser';
import React from 'react';
import './Contact.css';
import Swal from 'sweetalert2';
import { FiPhoneCall } from "react-icons/fi";
import { LuMapPin } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";

const Contact = () => {
   
    
    // const sendEmail = e =>{
    //     e.preventDefault();

    //     emailjs.sendForm('service_ofeehzp','template_fadvf2x',e.target,'user_IsZBcEwswacr9UZQ3NbFS')
    //     .then(res=>{
    //         alert('Massage done')
    //         console.log(res)})
    //     .catch(err=>console.log(err))
    // }


    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_2yhdyar', 'template_gb2229q', e.target, 'yYcbHAr7q3sv-yk9O')
          .then((result) => {
            Swal.fire(
                'Good job!',
                'Your has been sent!',
                'success'
              )
              console.log(result);
          }, (error) => {
              console.log(error.text);
          });
      };
    return (
        <div id="contact" className='container pb-5' style={{marginTop:'70px'}}>
            <div className="heading-section">
            <h4 className="text-white fw-bold mb-5"><span className="text-primary">Contact</span>  With Me</h4>
            </div>
           <div className='row '>
            <div className='col-md-6'>
                <div className='text-start pb-4'>
                    <h4>Contact Information</h4>
                    <p>If you interested or want to working with me, please contact or email me as soon as possible.</p>
                </div>

                <div className='d-flex  align-items-center  px-2 py-3 rounded border contact_div '>
                    <div className=' p-3 rounded-circle d-flex justify-content-center contact-first-div'>
                    <FiPhoneCall className='fs-5'/>
                    </div>
                    <div className='ps-4'>
                        <h6>Contact on phone</h6>
                        <h6>+88 01752 810246</h6>
                    </div>
                </div>
                <div className='d-flex  align-items-center  px-2 py-3 rounded border contact_div my-3'>
                    <div className=' p-3 rounded-circle d-flex justify-content-center contact-first-div'>
                    <MdOutlineEmail className='fs-5'/>
                    </div>
                    <div className=' text-start ps-4'>
                        <h6>Contact on Email</h6>
                        <h6>saharabanungn@gmail.com</h6>
                    </div>
                </div>
                <div className='d-flex  align-items-center  px-2 py-3 rounded border contact_div my-3'>
                    <div className=' p-3 rounded-circle d-flex justify-content-center contact-first-div'>
                    <LuMapPin className='fs-5'/>
                    </div>
                    <div className=' text-start ps-4'>
                        <h6>Contact Address</h6>
                        <h6>MoghBazar, Dhaka</h6>
                    </div>
                </div>
            </div>
            <div className="form-container col-md-6" data-aos="zoom-in-up"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="1000">
                <form onSubmit={sendEmail}>
                    <div className="form-group">
                       
                        <input type="text" name="name"  className="form-control" placeholder="Your Name" required />
                    </div>
                    <div className="form-group">
                       
                        <input type="email" name="user_email"  className="form-control" placeholder="Your Email" required/>
                    </div>
                    <div className="form-group">
                       
                        <textarea  name="message" cols="10" rows="4"  className="form-control" placeholder="Type Message" required></textarea>
                    </div>
                    <input type="submit" value="Send Message" />
                </form>

            </div>
           </div>

        </div>
    );
};

export default Contact;